import {
  redirectToProfileIfNotAdmin,
  redirectToProfileIfNotAdminOrTeamlead,
  redirectToProfileIfNotOffersV1AndNotAdmin,
} from '@/settings/router/guards';

const ProfilePage = () => import('@/settings/pages/account/profile.vue');
const GeneralPage = () => import('@/settings/pages/company/general.vue');
const SecurityPage = () => import('@/settings/pages/company/security.vue');
const ApiPage = () => import('@/settings/pages/company/api-key.vue');
const TeamMembersPage = () => import('@/settings/pages/company/team-members.vue');
const ApprovalChainsPage = () => import('@/settings/pages/offer/approval-chains.vue');
const ApprovalChainCreateEditPage = () => import('@/settings/pages/offer/approval-chain-create-edit.vue');
const JobArchitecturePage = () => import('@/settings/pages/company/job-architecture.vue');

export const settingsRoutes = [
  {
    path: '/settings',
    name: 'settings',
    redirect: { name: 'settings-account-profile' },
  },
  {
    path: '/settings/account/profile',
    name: 'settings-account-profile',
    component: ProfilePage,
    meta: {
      layout: 'layout-settings-default',
    },
  },
  {
    path: '/settings/company/general',
    name: 'settings-company-general',
    component: GeneralPage,
    beforeEnter: redirectToProfileIfNotAdmin,
    meta: {
      layout: 'layout-settings-default',
    },
  },
  {
    path: '/settings/company/team-members',
    name: 'settings-company-team-members',
    component: TeamMembersPage,
    beforeEnter: redirectToProfileIfNotAdminOrTeamlead,
    meta: {
      layout: 'layout-settings-default',
    },
  },
  {
    path: '/settings/company/security',
    name: 'settings-company-security',
    component: SecurityPage,
    beforeEnter: redirectToProfileIfNotAdmin,
    meta: {
      layout: 'layout-settings-default',
    },
  },
  {
    path: '/settings/company/api',
    name: 'settings-company-api',
    component: ApiPage,
    beforeEnter: redirectToProfileIfNotAdmin,
    meta: {
      layout: 'layout-settings-default',
    },
  },
  // Offers V1
  {
    path: '/settings/offer/approval-chains',
    name: 'settings-offer-approval-chains',
    component: ApprovalChainsPage,
    beforeEnter: redirectToProfileIfNotOffersV1AndNotAdmin,
    meta: {
      layout: 'layout-settings-default',
    },
  },
  {
    path: '/settings/offer/approval-chains/create',
    name: 'settings-offer-approval-chain-create',
    component: ApprovalChainCreateEditPage,
    beforeEnter: redirectToProfileIfNotOffersV1AndNotAdmin,
    meta: {
      layout: 'layout-settings-default',
    },
  },
  {
    path: '/settings/offer/approval-chains/edit/:id',
    name: 'settings-offer-approval-chain-edit',
    component: ApprovalChainCreateEditPage,
    beforeEnter: redirectToProfileIfNotOffersV1AndNotAdmin,
    meta: {
      layout: 'layout-settings-default',
    },
  },
  {
    path: '/settings/company/job-architecture',
    name: 'settings-company-job-architecture',
    component: JobArchitecturePage,
    beforeEnter: redirectToProfileIfNotAdmin,
    meta: {
      layout: 'layout-settings-default',
    },
  },
];
